export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ops, ocorreu um erro!"])}
}